export function getMetaNumber(meta, id, param) {
    if (meta === undefined) {
        return 0;
    }
    for (let i = 0; i < meta.length; i++) {
        if (meta[i].id === id && meta[i].param[0] === param) {
            return Number(meta[i].param[1]);
        }
    }
    return 0;
}
